import React, { useCallback, useRef, useState } from 'react';

function useInfinitePagination<T, TRef extends HTMLElement>(
  data: T[],
  container: TRef | null
): [T[], () => void, boolean] {
  const getPage = useCallback(
    (page: number) => data.slice(0, (page + 1) * size),
    [data]
  );
  const size = 25;
  const [pageNum, setPageNum] = useState(0);
  const showedData = getPage(pageNum);
  const hasMore = showedData.length !== data.length;

  const getNextPage = useCallback(() => {
    var promise = new Promise<{ page: any[]; pageNum: number }>((resolve) => {
      setTimeout(() => {
        const nextPage = pageNum + 1;
        const page = getPage(nextPage);
        resolve({ page, pageNum: nextPage });
      });
    });
    return promise;
  }, [pageNum, getPage]);

  const goNextPage = useCallback(async () => {
    const { pageNum } = await getNextPage();
    setPageNum(pageNum);
  }, [setPageNum, getNextPage]);

  return [showedData, goNextPage, hasMore];
}

export function useInfinitePaginationWithRoot<T>(
  data: T[]
): [T[], () => void, boolean] {
  const root = document.documentElement;
  const pagination = useInfinitePagination(data, root);
  return pagination;
}

export function useInfinitePaginationWithRef<T, TRef extends HTMLElement>(
  data: T[]
): [T[], () => void, boolean, React.RefObject<TRef>] {
  const containerRef = useRef<TRef>(null);
  const pagination = useInfinitePagination(data, containerRef.current);
  const result = [...pagination, containerRef] as [
    T[],
    () => void,
    boolean,
    React.RefObject<TRef>
  ];
  return result;
}
